import axios from "../lib/axios";
import { API_WEB } from "../utils/constants";

// CSRF Token API Function
const csrf = () => axios.get("/sanctum/csrf-cookie");

export async function freeOfferRedeem({ offerId }) {
    await csrf();

    const response = await axios.post(
        `${API_WEB}/offers/${offerId}/redeem-free-lecture`
    );

    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error(response.response.data.message);
    }
}
